/**
 * Opens the Tidio chat widget.
 */
const openTidioChat = () => {
  if (window.tidioChatApi) {
    window.tidioChatApi.show();
    window.tidioChatApi.open();
    return;
  }

  document.addEventListener(
    'tidioChat-ready',
    () => {
      window.tidioChatApi?.show();
      window.tidioChatApi?.open();
    },
    { once: true }
  );
};

/**
 * @param {MouseEvent} event
 */
const handleChatTriggerClick = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest('.chat-button, a[href="#chat"]');
  if (!trigger) return;

  event.preventDefault();
  openTidioChat();
};

document.addEventListener('click', handleChatTriggerClick);
